// Customizable alert sounds synthesized with the Web Audio API (no assets needed).
export const ALARMS = [
  { id: "chime", label: "Carillon" },
  { id: "bell", label: "Cloche" },
  { id: "alert", label: "Alarme" },
  { id: "soft", label: "Douce" },
];

export const getAlarm = () => localStorage.getItem("omy_alarm") || "chime";
export const setAlarm = (v) => localStorage.setItem("omy_alarm", v);

let ctx;
const ac = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  return ctx;
};

function beep(c, freq, start, dur, type = "sine", gain = 0.18) {
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(c.destination);
  const t = c.currentTime + start;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur + 0.03);
}

export function playAlarm(id = getAlarm()) {
  try {
    const c = ac();
    if (c.state === "suspended") c.resume();
    if (id === "bell") {
      beep(c, 987, 0, 1.0, "triangle", 0.22);
      beep(c, 1318, 0, 1.0, "sine", 0.10);
    } else if (id === "alert") {
      for (let i = 0; i < 4; i++) beep(c, 1046, i * 0.22, 0.13, "square", 0.2);
    } else if (id === "soft") {
      beep(c, 523, 0, 0.5, "sine", 0.14);
      beep(c, 659, 0.18, 0.55, "sine", 0.12);
    } else {
      beep(c, 659, 0, 0.5, "sine", 0.16);
      beep(c, 784, 0.16, 0.5, "sine", 0.16);
      beep(c, 1046, 0.32, 0.75, "sine", 0.16);
    }
  } catch (e) {}
}
